export default "__VITE_ASSET__8HZA_sZW__"